// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b1c9ef0d","132":"42dd091e","235":"e22e6b7d","309":"b57bef68","320":"54582e45","333":"94da857e","565":"b1e5ec7f","808":"50fbd93c","831":"a94fb409","843":"752a84a2","845":"4833d6f4","928":"bd014d60"}[chunkId] + ".chunk.js";
};